import Vue from 'vue'
import hljs from 'highlight.js/lib/core'
import vuePlugin from '@highlightjs/vue-plugin'
import xml from 'highlight.js/lib/languages/xml'

hljs.registerLanguage('xml', xml)
Vue.use(vuePlugin)

export default vuePlugin
